<div class="modal"
     #form
     [formGroup]="formGroup"
     novalidate>
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2 class="mb-0075"> {{isCreate ? 'Add' : 'Update'}} Social Media Profile</h2>

  <mat-form-field class="col__"
                  required>
    <mat-label>Type</mat-label>
    <mat-select formControlName="network" [disabled]="!isCreate">
      <mat-option *ngFor="let network of socialTypes"
                  [value]="network.id">{{network.label}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="col__"
                  *ngIf="selectedNetwork">
    <mat-label *ngIf="selectedNetwork !== 'other' && selectedNetwork !== 'website' && selectedNetwork !== 'wechat'">Handle / URL</mat-label>
    <mat-label *ngIf="selectedNetwork === 'other' || selectedNetwork === 'website'">URL</mat-label>
    <mat-label *ngIf="selectedNetwork === 'wechat'">Handle</mat-label>
    <input matInput
           formControlName="profile" />
  </mat-form-field>

  <ng-container *ngIf="selectedNetwork === 'other'">
    <mat-form-field class="col__">
      <mat-label>Label</mat-label>
      <input matInput formControlName="label"/>
    </mat-form-field>

  </ng-container>

  <div class="col__ col__xs--50  col__md--50 bot-0025">
    <mat-checkbox disableRipple formControlName="verified">Confirmed
    </mat-checkbox>
  </div>


  <ng-container *ngIf="parsedResult">
    <div *ngIf="parsedResult.isValid">
      <span style="word-break: break-all;">
        <i class="pr-0025 {{getSocialIconClass(parsedResult.profile)}}"></i>
        {{parsedResult.profile}}
        <span *ngIf="parsedResult.profile !== 'other' && parsedResult.profile !== 'website'">- {{parsedResult.profileId}} </span>
        <span *ngIf="parsedResult.profile === 'other'">- {{formGroup.value.label}} </span>
      </span>
      <span class="d-inline-block" style="word-break: break-all;" *ngIf="parsedResult.profile !== 'wechat'">
        (<a class="link link--blue link--noline"
         [attr.href]="parsedResult.sanitized"
         target="_blank"> {{parsedResult.sanitized}}
        </a>)
      </span>
    </div>

    <div *ngIf="!parsedResult.isValid">
      <span>Not a valid {{getSocialName(selectedNetwork)}} URL / Handle</span>
    </div>
  </ng-container>


  <div class="col__ mt-0075"
       content-outlet="buttons">
    <button class="btn floatRight"
            type="button"
            [appButtonSpinner]="isSaving"
            [disabled]="!isValid()"
            (click)="onSaveClicked()">Save</button>
  </div>

</div>
